module.exports = __webpack_public_path__ + "img/BAU_Partners_8.45c4c7f1.jpg";